import getConsumerMailboxOptions from '../services/getConsumerMailboxOptions';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import { action } from 'satcheljs/lib/legacy';

export default action('loadConsumerMailboxOptions')(async function loadConsumerMailboxOptions() {
    const options = await getConsumerMailboxOptions();
    if (options) {
        const userConfig = getUserConfiguration();
        userConfig.SessionSettings.UserProxyAddresses = options.EmailAddresses;
        userConfig.SessionSettings.NotManagedEmailAddresses = options.NotManagedEmailAddresses;
    }
});
